

const WithConditional = ({children, when}) => {
    return when && children
}

export default WithConditional;